import {
    Configuration,
    InlineResponse2007,
    ListingTypeApi
} from 'hotdesk_typescript';
import { fetchRemoteConfig } from '../common-classes/firebase.service';
import { RemoteConfigKeys } from '../enum/remote-keys';

/**
 * Display order for listing types, by id (labels are translated, ids are
 * stable): Desks, Meeting Rooms, Office Rooms, Creator Space, Virtual Offices,
 * Training/Lecture Rooms. The API returns them in its own order. Ids not
 * listed keep their API order after these.
 */
export const LISTING_TYPE_DISPLAY_ORDER = [1, 2, 3, 6, 8, 7];

export function sortListingTypes<T extends { id?: number | null }>(
    types: T[]
): T[] {
    const rank = (t: T) => {
        const i = LISTING_TYPE_DISPLAY_ORDER.indexOf(Number(t.id));
        return i === -1 ? LISTING_TYPE_DISPLAY_ORDER.length : i;
    };
    // Array.prototype.sort is stable, so unknown ids keep their API order.
    return [...types].sort((a, b) => rank(a) - rank(b));
}

export class ListingTypeService {
    private listingTypeApi!: ListingTypeApi;
    listingType!: string;
    constructor(apiConfig: Configuration) {
        this.listingTypeApi = new ListingTypeApi(apiConfig);
    }

    async getListingType(browserLanguage: string): Promise<InlineResponse2007> {
        this.listingType = (await fetchRemoteConfig(
            RemoteConfigKeys.HD_LISTING_TYPES_KEY,
            'string'
        )) as string;
        try {
            const res = await this.listingTypeApi.listingTypeList({
                limit: 10,
                idIn: this.listingType,
                lang: browserLanguage
            });
            if (res?.results) {
                res.results = sortListingTypes(res.results);
            }
            return res;
        } catch (error) {
            throw error;
        }
    }
}
